import type { DocStorage } from '@affine/nbstore';

import {
  AFFiNE_WORKSPACE_DB_SCHEMA,
  AFFiNE_WORKSPACE_USERDATA_DB_SCHEMA,
} from './schema';

export const DUPLICATED_WORKSPACE_DB_TABLES = [
  'folders',
  'docProperties',
  'docCustomPropertyInfo',
  'pinnedCollections',
  'explorerIcon',
] as const satisfies readonly (keyof typeof AFFiNE_WORKSPACE_DB_SCHEMA)[];

export async function copyWorkspaceContentDB(
  sourceDocStorage: DocStorage,
  destinationDocStorage: DocStorage
) {
  for (const tableName of DUPLICATED_WORKSPACE_DB_TABLES) {
    const docId = `db$${tableName}`;
    const sourceDoc = await sourceDocStorage.getDoc(docId);
    if (sourceDoc) {
      await destinationDocStorage.pushDocUpdate({
        docId,
        bin: sourceDoc.bin,
      });
    }
  }
}

export async function transformWorkspaceDBLocalToCloud(
  _localWorkspaceId: string,
  _cloudWorkspaceId: string,
  localDocStorage: DocStorage,
  cloudDocStorage: DocStorage,
  accountId: string
) {
  for (const tableName of Object.keys(AFFiNE_WORKSPACE_DB_SCHEMA)) {
    const localDocName = `db$${tableName}`;
    const localDoc = await localDocStorage.getDoc(localDocName);
    if (localDoc) {
      const cloudDocName = `db$${tableName}`;
      await cloudDocStorage.pushDocUpdate({
        docId: cloudDocName,
        bin: localDoc.bin,
      });
    }
  }

  for (const tableName of Object.keys(AFFiNE_WORKSPACE_USERDATA_DB_SCHEMA)) {
    const localDocName = `userdata$__local__$${tableName}`;
    const localDoc = await localDocStorage.getDoc(localDocName);
    if (localDoc) {
      const cloudDocName = `userdata$${accountId}$${tableName}`;
      await cloudDocStorage.pushDocUpdate({
        docId: cloudDocName,
        bin: localDoc.bin,
      });
    }
  }
}
